import { fetchData } from "@/lib/api/fetchData";
import { formatRules } from "@/lib/formatter/rules";

export const getRulesForTable = async () => {
  try {
    const res = await fetchData("/rules");

    return formatRules(res.data);
  } catch (error) {
    console.error(error);
    throw new Error("Failed to load rules");
  }
};

export const getRuleById = async (id) => {
  try {
    const res = await fetchData(`/rules/${id}`);

    return res.data;
  } catch (error) {
    console.error(error);
    throw new Error("Failed to load rule");
  }
};

export const getRulesForSelect = async () => {
  try {
    const res = await fetchData("/rules");

    return res.data.map((rule) => ({
      value: rule["@id"],
      label: rule["name"],
    }));
  } catch (error) {
    console.error(error);
    throw new Error("Failed to load rules");
  }
};
